import React from "react";
import { Layout, WithdrawalShareBonus } from "../components";

const WithdrawalSharePage = () => {
  return (
    <>
      <Layout>
        <WithdrawalShareBonus />
      </Layout>
    </>
  );
};

export default WithdrawalSharePage;
